var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotSupported(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 253,
    height: 235,
    viewBox: "0 0 253 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12172_63163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.135 62.8203H52.5449C50.4593 62.8216 48.4595 63.6522 46.9848 65.1295C45.5101 66.6069 44.681 68.6103 44.6797 70.6997V212.791C44.681 214.881 45.5101 216.884 46.9848 218.361C48.4595 219.839 50.4593 220.669 52.5449 220.671H207.135C209.221 220.67 211.221 219.839 212.696 218.362C214.171 216.884 215 214.881 215.001 212.791V70.6997C215 68.6102 214.171 66.6067 212.696 65.1293C211.221 63.6519 209.221 62.8214 207.135 62.8203Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2969 104.059L116.727 129.535H91.2969V104.059Z",
    fill: "url(#paint0_linear_12172_63163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9355 173.218V47.6738C52.9355 43.3224 56.4572 39.7944 60.8007 39.7944H195.036C196.57 39.7944 197.996 40.2411 199.205 41.0019C197.815 38.7806 195.356 37.2998 192.545 37.2998H58.3106C53.967 37.2998 50.4453 40.8278 50.4453 45.1791V170.725C50.4453 173.541 51.9235 176.004 54.1408 177.397C53.3814 176.185 52.9355 174.756 52.9355 173.219V173.218Z",
    fill: "url(#paint1_linear_12172_63163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.944 181.01H60.709C56.3654 181.01 52.8438 177.482 52.8438 173.131V47.5854C52.8438 43.234 56.3654 39.7061 60.709 39.7061H194.944C199.287 39.7061 202.809 43.234 202.809 47.5854V173.131C202.809 177.482 199.287 181.01 194.944 181.01Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.436 66.2285H77.2346V72.0062H178.436V66.2285ZM178.436 88.2897H77.2346V94.0674H178.436V88.2897ZM178.436 110.356H77.2346V116.133H178.436V110.356ZM178.436 132.417H77.2346V138.195H178.436V132.417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.924 136.937L215.958 214.698C215.41 218.586 212.089 221.475 208.17 221.475H51.5134C47.5945 221.475 44.2735 218.586 43.7253 214.698L28.9068 109.623C28.2384 104.88 31.9127 100.642 36.6949 100.642H85.0739C88.9927 100.642 92.3138 103.531 92.862 107.418L94.8039 121.178C95.3522 125.066 98.6732 127.955 102.592 127.955H219.137C223.918 127.955 227.593 132.193 226.925 136.937H226.924Z",
    fill: "url(#paint2_linear_12172_63163)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.069 186.791H71.6102C70.9718 186.79 70.3555 186.557 69.8766 186.134C69.3977 185.711 69.0892 185.128 69.0087 184.494L67.5516 172.937C67.5054 172.567 67.5381 172.192 67.6476 171.835C67.7572 171.479 67.941 171.151 68.1871 170.871C68.4331 170.592 68.7356 170.368 69.0745 170.215C69.4135 170.061 69.7812 169.982 70.1531 169.981H189.526C189.898 169.982 190.266 170.061 190.605 170.215C190.944 170.368 191.247 170.592 191.493 170.871C191.739 171.151 191.922 171.479 192.032 171.835C192.142 172.192 192.174 172.567 192.128 172.937L190.671 184.494C190.59 185.128 190.282 185.711 189.803 186.134C189.324 186.557 188.708 186.79 188.069 186.791V186.791Z",
    fill: "#E8E8E8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202.59 161H228.656C230.254 161 231.73 161.612 232.836 162.712L251.279 181.06C252.385 182.16 253 183.628 253 185.218V211.026C253 212.617 252.385 214.084 251.279 215.185L233.082 233.288C231.975 234.388 230.5 235 228.902 235H202.59C200.992 235 199.516 234.388 198.41 233.288L179.721 214.696C178.615 213.595 178 212.127 178 210.537V185.218C178 183.628 178.615 182.16 179.721 181.06L198.287 162.712C199.516 161.612 200.992 161 202.59 161Z",
    fill: "url(#paint3_linear_12172_63163)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M217.625 217.074L217.502 212.25H214.438C210.008 212.25 206.244 210.701 203.147 207.603C200.049 204.506 198.5 200.742 198.5 196.312C198.5 191.883 200.049 188.119 203.147 185.022C206.244 181.924 210.008 180.375 214.438 180.375C216.652 180.375 218.726 180.79 220.66 181.62C222.592 182.449 224.28 183.584 225.723 185.027C227.166 186.47 228.301 188.158 229.13 190.091C229.96 192.024 230.375 194.098 230.375 196.312C230.375 198.479 230.057 200.559 229.421 202.554C228.783 204.547 227.904 206.432 226.782 208.208C225.657 209.985 224.311 211.621 222.744 213.117C221.177 214.613 219.471 215.931 217.625 217.072M214.508 207.088C214.947 207.088 215.317 206.937 215.619 206.636C215.921 206.333 216.072 205.962 216.072 205.524C216.072 205.085 215.921 204.715 215.619 204.413C215.316 204.11 214.945 203.958 214.508 203.958C214.068 203.958 213.698 204.11 213.396 204.413C213.093 204.715 212.941 205.085 212.941 205.524C212.941 205.964 213.093 206.334 213.396 206.636C213.698 206.937 214.068 207.088 214.508 207.088ZM213.579 200.873H215.46C215.513 200.001 215.681 199.312 215.961 198.805C216.242 198.298 216.907 197.519 217.959 196.468C218.569 195.858 219.053 195.236 219.41 194.6C219.767 193.965 219.946 193.236 219.946 192.413C219.946 190.88 219.416 189.676 218.358 188.801C217.3 187.924 216.02 187.485 214.518 187.485C213.206 187.485 212.094 187.844 211.182 188.563C210.268 189.281 209.599 190.137 209.174 191.132L210.923 191.81C211.209 191.181 211.627 190.608 212.176 190.091C212.728 189.575 213.508 189.317 214.518 189.317C215.721 189.317 216.609 189.644 217.181 190.297C217.755 190.951 218.042 191.665 218.042 192.439C218.042 193.15 217.857 193.751 217.489 194.243C217.121 194.734 216.648 195.269 216.072 195.847C215.052 196.745 214.381 197.553 214.059 198.27C213.739 198.984 213.579 199.851 213.579 200.873Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12172_63163",
    x1: 108.099,
    y1: 133.623,
    x2: 77.3047,
    y2: 102.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12172_63163",
    x1: 130.04,
    y1: 112.564,
    x2: 30.3931,
    y2: 13.0939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12172_63163",
    x1: 127.915,
    y1: 100.642,
    x2: 127.915,
    y2: 221.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12172_63163",
    x1: 178,
    y1: 161,
    x2: 272.748,
    y2: 178.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E8AB0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12172_63163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 227,
    height: 225,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSupported);
export default __webpack_public_path__ + "static/media/notSupported.773437b793ef674b5303dbef8c75e9e0.svg";
export { ForwardRef as ReactComponent };